export default __webpack_public_path__ + "media/images/ui-bg_glass_55_fbf9ee_1x400-aba48d728d126c15ffac4b8d94d8d27b.png";